'use strict';

/**
 * Sistema de modais da Odonto Luz
 * Gerencia todos os modais para dentistas, agendamentos, contatos e alertas
 */
const modal_odonto = {
    /**
     * Realiza requisições AJAX usando fetch API
     * @param {string} caminho - Caminho relativo do endpoint 
     * @param {string} send - Dados a serem enviados
     * @param {Function} callback - Função de callback para processar a resposta
     * @returns {Promise} - Promise com o resultado da requisição
     */
    async ajax(caminho, send, callback) {
        const body = $('body');
        let data;

        // Falha de rede ou resposta que não é JSON também chega ao callback, como
        // { type: 'error' }. Até 2026-09-16 o callback só rodava no sucesso do parse:
        // sem rede, o botão do formulário ficava desabilitado e a tela não dizia nada.
        // O callback roda FORA do try de propósito — uma exceção dentro dele não pode
        // virar uma segunda chamada com "erro" depois de um envio que deu certo.
        try {
            body.addClass('loader');

            const response = await fetch(`/ajax/no-sw/${caminho}.php`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                body: send
            });

            data = await response.json();
        } catch (erro) {
            console.error(`Erro na requisição para ${caminho}:`, erro);
            data = { type: 'error', message: erro.message };
        } finally {
            body.removeClass('loader');
        }

        if (callback && typeof callback === 'function') {
            callback(data);
        }

        return data;
    },

    md: '',

    // Each error belongs to its field; focus exposes the same text to screen readers.
    erroCampo: (campo, mensagem) => {
        const id = campo.attr('id') + '-erro';
        campo.attr('aria-invalid', mensagem ? 'true' : 'false');
        $('#' + id).text(mensagem || '').toggleClass('hide', !mensagem);
        return !!mensagem;
    },

    preparaFormulario: (form) => {
        form.off('.acessibilidade').on('input.acessibilidade', 'input, textarea', function () {
            modal_odonto.erroCampo($(this), '');
        }).on('keydown.acessibilidade', 'input', function (event) {
            if (event.key === 'Enter' && !event.isComposing) {
                event.preventDefault();
                form.find('#agendar-confirma').trigger('click');
            }
        });
        form.find('input').first().trigger('focus');
    },

    validaFormulario: (form, erros) => {
        let primeiro = null;
        form.find('input, textarea').each(function () {
            const campo = $(this);
            let erro = erros ? (erros[this.name] || '') : '';
            if (!erros) {
                const valor = String(campo.val() || '').trim();
                if (this.name === 'nome' && (Array.from(valor).length < 2 || Array.from(valor).length > 120 || !/\p{L}/u.test(valor))) erro = 'Informe seu nome, entre 2 e 120 caracteres.';
                if (this.name === 'telefone' && !/^[1-9][0-9](?:[2-9]\d{7}|9\d{8})$/.test(valor.replace(/\D/g, ''))) erro = 'Informe um telefone válido com DDD.';
                if (this.name === 'msg' && (!valor || Array.from(valor).length > 5000)) erro = 'Escreva sua mensagem, com até 5.000 caracteres.';
            }
            if (modal_odonto.erroCampo(campo, erro) && !primeiro) primeiro = campo;
        });
        if (primeiro) primeiro.trigger('focus');
        return !primeiro;
    },

    /**
     * Escapa texto do visitante antes de devolvê-lo ao HTML do modal.
     * O nome e o e-mail digitados voltam para a tela de confirmação; sem isto
     * um `<` no campo vira markup.
     */
    escapa: (txt) => String(txt === null || txt === undefined ? '' : txt)
        .replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c])),

    /**
     * Botão de WhatsApp para a tela de confirmação.
     *
     * O número NÃO é literal aqui: sai do DOM, do mesmo `data-tel` que o menu e
     * o rodapé já publicam (include/nav.php). É esse atributo que carrega a
     * regra de plantão de include/config.php (titular × relacionamento) — um
     * número fixo no JS passaria por cima dela em silêncio. Sem `data-tel` na
     * página, devolve string vazia e a tela fica só com o comprovante.
     *
     * O <a> nasce com href real (fallback sem JS) e com data-whatsapp="true":
     * quem trata o clique é js/modulo/whatsapp.js, que faz o preventDefault,
     * empurra `whatsapp_click` no dataLayer e acrescenta o [ref: ] do clique
     * pago. Por isso o chamador precisa rodar `whatsapp.init()` depois de
     * injetar — a guarda data-whatsapp-bound do módulo evita duplo listener.
     *
     * `data-origem="modal-agendamento"` rotula o clique para js/modulo/whatsapp.js
     * (vence a derivação por posição no DOM, que daria 'pagina'). Não é cosmético:
     * o GTM usa esse valor como EXCEÇÃO na tag `Ads - Conversão WhatsApp Bridge`
     * (versão 36, 2026-09-13). Quem chega a esta tela já converteu pelo formulário
     * (`agendamento_enviado`, primária); sem a exceção o mesmo lead contaria uma
     * segunda conversão primária. Renomear o valor exige mudar o acionador no GTM.
     *
     * @param {string} mensagem - Texto que abre a conversa
     * @returns {string} HTML do botão, ou '' quando não há número na página
     */
    whatsappBotao: (mensagem) => {
        const tel = String($('[data-whatsapp="true"][data-tel]').first().data('tel') || '').replace(/\D+/g, '');

        if (tel.length < 10 || tel.length > 11) {
            return '';
        }

        const href = `https://api.whatsapp.com/send?phone=55${tel}&text=${encodeURIComponent(mensagem)}`;

        return `<a href="${modal_odonto.escapa(href)}" target="_blank" rel="noopener"
                    data-whatsapp="true" data-origem="modal-agendamento" data-tel="${tel}" data-msg="${modal_odonto.escapa(mensagem)}"
                    class="btn btn-default btn-block btn-lg"><i class="fa fa-whatsapp" aria-hidden="true"></i>&nbsp; Falar agora no WhatsApp</a>`;
    },

    /**
     * Liga os botões recém-injetados numa tela de confirmação.
     */
    ativaBotoes: () => {
        modal_odonto.md.find('.modal-sucesso').first().trigger('focus');
        if (typeof whatsapp !== 'undefined' && whatsapp && typeof whatsapp.init === 'function') {
            whatsapp.init();
        }
    },

    /**
     * Cria a estrutura HTML base para o modal
     * @returns {Object} Objeto jQuery representando o modal
     */
    modal_html: () => {
        const md_id = 'modal-perfil-dentista';
        // A barra é sticky no topo da COLUNA de leitura: o X mora no canto do
        // conteúdo (padrão de folha), não da tela — fixo na viewport, a 1920px
        // ele ficava ~630px longe do texto (feedback 2026-08-21).
        const close_btn = '<div class="modal-barra"><button type="button" class="close" data-dismiss="modal" aria-label="Fechar"><span aria-hidden="true">&times;</span></button></div>';

        modal_odonto.md = `
            <div id="${md_id}" class="modal fade" tabindex="-1" role="dialog" aria-modal="true" aria-label="Odonto Luz">
                <div class="modal-dialog modal-meu-dentista">
                    <div class="modal-content">
                        <div class="modal-body">${close_btn}</div>
                    </div>
                </div>
            </div>`;

        // Verifica se o modal já existe no DOM
        if (!$(`#${md_id}`).length) {
            $('body').append(modal_odonto.md);
        }

        modal_odonto.md = $(`#${md_id}`);

        modal_odonto.md.off('.acessibilidade')
            .on('show.bs.modal.acessibilidade', () => {
                modal_odonto.focoAnterior = document.activeElement;
            })
            .on('shown.bs.modal.acessibilidade', () => {
                const titulo = modal_odonto.md.find('h2, h3').first().text().trim();
                modal_odonto.md.attr('aria-label', titulo || 'Odonto Luz');
                modal_odonto.md.find('input:visible, button:visible').first().trigger('focus');
            })
            .on('hidden.bs.modal.acessibilidade', () => {
                const anterior = modal_odonto.focoAnterior;
                if (anterior && anterior.isConnected && typeof anterior.focus === 'function') anterior.focus();
            });

        // TRAVA DE ROLAGEM DO FUNDO (2026-08-21). O Bootstrap põe overflow:hidden
        // no <body> e conta com a propagação body → viewport. Aqui ela NÃO
        // acontece: css/style.css declara `html{overflow-x:hidden}`, e overflow
        // não-visível no <html> cancela a propagação — quem rola passa a ser o
        // próprio <html>, que o Bootstrap não toca. Medido: com o modal aberto o
        // fundo rolava 800px. Travar o <html> é o que de fato segura.
        // No documento (os eventos do Bootstrap sobem), então vale para TODOS os
        // modais do site, inclusive o alertm — e não só para este shell.
        // Namespace + off(): int() roda de novo a cada navegação AJAX.
        $(document).off('.travarolagem')
            .on('show.bs.modal.travarolagem', () => {
                document.documentElement.classList.add('modal-travado');
            })
            .on('hidden.bs.modal.travarolagem', () => {
                // só destrava se não sobrou nenhum outro modal aberto
                if (!document.querySelector('.modal.in')) {
                    document.documentElement.classList.remove('modal-travado');
                }
            });

        // Limpa o conteúdo ao fechar o modal
        modal_odonto.md.off('hidden.bs.modal.limpeza').on('hidden.bs.modal.limpeza', () => {
            modal_odonto.md.find('.modal-body').off().html(close_btn);
            modal_odonto.md.removeClass('agendamento');
            modal_odonto.perfil_rota.limpa();
        });

        return modal_odonto.md;
    },

    /**
     * Funções relacionadas ao agendamento
     */
    agendamento: {
        /**
         * Exibe o modal de agendamento
         * @param {string} assunto - Assunto do agendamento
         * @param {string} [origem] - região do botão que abriu o formulário
         *   (origemDoClique(), js/modulo/whatsapp.js); vai no agendamento_enviado
         *   como agendamento_origem, a mesma régua de whatsapp_origem/tel_origem.
         */
        modal: (assunto, origem) => {
            assunto = assunto || "Pedir horário de avaliação";
            origem = origem || 'desconhecida';
            const form = 'form-agenda';
            const thecontent = modal_odonto.md.find('#the-content');

            modal_odonto.md.addClass('agendamento');

            // Adiciona o HTML ao modal
            if (!thecontent.length) {
                modal_odonto.md.find('.modal-body').append(`
                    <div id="the-content">
                        <h3 class="modal-titulo">${modal_odonto.escapa(assunto)}</h3>
                    </div>`);
            }

            modal_odonto.md.find('#the-content').off().append(`
                <div id="${form}" class="text-left animation delay fadeInUp">
                    <p>Deixe seu nome e telefone. Nossa equipe entra em contato para combinar unidade, dia e horário da avaliação.</p>
                    <label for="${form}-nome">Seu nome</label>
                    <small id="${form}-nome-erro" class="modal-aviso hide"></small>
                    <input id="${form}-nome" name="nome" class="form-control" type="text" autocomplete="name" required minlength="2" maxlength="120" aria-describedby="${form}-nome-erro" placeholder="Seu nome">
                    <br>
                    <label for="${form}-telefone">Telefone <small>ou Whatsapp</small></label>
                    <small id="${form}-telefone-erro" class="modal-aviso hide"></small>
                    <input id="${form}-telefone" name="telefone" class="form-control" type="tel" autocomplete="tel-national" inputmode="tel" required maxlength="15" aria-describedby="${form}-telefone-erro" placeholder="celular ou fixo">
                    <div class="modal-acao"><button id="agendar-confirma" class="btn btn-default custom-size offline-hide">Enviar pedido</button></div>
                </div>`);

            const formElement = modal_odonto.md.find(`#${form}`);
            modal_odonto.preparaFormulario(formElement);

            // Mensagem do WhatsApp do desfecho, guardada no escopo do modal.
            // A tela de comprovante é renderizada por email(), que roda depois e não
            // enxerga o nome digitado no handler de envio. Sem guardar aqui, quem
            // escolhe "Receber comprovante por e-mail" PERDE a saída primária: o
            // formElement.html() da tela de comprovante substitui a tela inteira,
            // e o botão de WhatsApp não voltava em nenhuma das telas seguintes
            // (achado de 2026-09-12, um dia depois de o botão ir ao ar).
            // Vazia até o agendamento ser aceito — e whatsappBotao() só é chamado
            // com ela preenchida, para não emitir faixa de ação sem ação dentro.
            let zapMsg = '';

            // Função para envio de email
            // Recebe o token de uso único de ajax/no-sw/agendamento.php — não mais o id
            // do contato, que era sequencial e abria o comprovante de qualquer lead (IDOR,
            // fechado em 2026-09-16). O token vale para UM envio: depois do primeiro,
            // tentar de novo com ele só devolve erro.
            const email = (comprovanteToken) => {
                const renderEmailResult = (response, emailDestino) => {
                    const destino = modal_odonto.escapa(emailDestino);
                    const zap = zapMsg ? modal_odonto.whatsappBotao(zapMsg) : '';
                    const acoes = zap ? `<div class="modal-sucesso-acoes">${zap}</div>` : '';

                    // O chamador decide pelo VALOR DE VERDADE deste retorno
                    // (`if (renderEmailResult(...)) return null;`): devolver o
                    // resultado de ativaBotoes() faria um envio bem-sucedido
                    // virar "não foi possível enviar" quando o módulo whatsapp
                    // não estivesse carregado. Por isso devolve o formElement.
                    const desenha = (html) => {
                        formElement.html(html);
                        modal_odonto.ativaBotoes();
                        return formElement;
                    };

                    if (response.type === 'success' && response.delivery_status === 'processing') {
                        return desenha(`
                            <div class="modal-sucesso" role="status" tabindex="-1">
                                <p class="modal-sucesso-selo">Comprovante ⏳</p>
                                <p class="modal-sucesso-titulo">Está sendo enviado agora</p>
                                <p class="modal-sucesso-texto">para: <b>${destino}</b></p>
                                <p class="modal-sucesso-nota">Isso pode levar alguns segundos. Você não precisa clicar novamente.</p>
                                ${acoes}
                            </div>`);
                    }

                    if (response.type === 'success') {
                        return desenha(`
                            <div class="modal-sucesso" role="status" tabindex="-1">
                                <p class="modal-sucesso-selo">Comprovante 😄</p>
                                <p class="modal-sucesso-titulo">Enviado com sucesso!</p>
                                <p class="modal-sucesso-texto">para: <b>${destino}</b></p>
                                ${acoes}
                            </div>`);
                    }

                    return null;
                };

                formElement.off().html(`
                    <br>
                    <label for="${form}-email">Digite seu e-mail</label>
                    <small id="${form}-email-erro" class="modal-aviso hide" data-role="email-error">Informe um e-mail válido.</small>
                    <input id="${form}-email" name="email" class="form-control" type="email" autocomplete="email" required maxlength="254" aria-describedby="${form}-email-erro" placeholder="Seu e-mail">
                    <br>
                    <p class="modal-texto hide" data-role="email-status" role="status" aria-live="polite"><small></small></p>
                    <div class="modal-acao"><button id="agendar-confirma" class="btn btn-default custom-size offline-hide">Enviar comprovante</button></div>`)
                    .find('#agendar-confirma').off()
                    .on('click', async function () {
                        const button = $(this);
                        const input = formElement.find('input[name="email"]');
                        const validationHint = formElement.find('[data-role="email-error"]');
                        const statusHint = formElement.find('[data-role="email-status"]');
                        const emailDestino = input.val().trim();

                        if (button.prop('disabled')) {
                            return null;
                        }

                        if (modal_odonto.erroCampo(input, !$FUNC.email(emailDestino) || emailDestino.length > 254 ? 'Informe um e-mail válido.' : '')) {
                            input.focus();
                            validationHint.removeClass('hide');
                            statusHint.addClass('hide').find('small').text('');
                            return null;
                        }

                        validationHint.addClass('hide');
                        input.prop('disabled', true);
                        button.prop('disabled', true).text('Enviando…');
                        statusHint.removeClass('hide').find('small').text('Enviando as informações. Aguarde alguns segundos...');

                        const response = await modal_odonto.ajax(
                            'cliente_email',
                            new URLSearchParams({ token: comprovanteToken, email: emailDestino }).toString()
                        );

                        if (renderEmailResult(response, emailDestino)) {
                            return null;
                        }

                        // Tentar de novo só faz sentido se o token AINDA vale: e-mail recusado
                        // pelo servidor (`email_invalido`, token intocado) ou falha de rede
                        // (sem `motivo` — a requisição pode nem ter chegado). Com `indisponivel`
                        // o token já foi gasto ou venceu (a tela pode ficar aberta mais que os
                        // 30 min de validade), e "tente novamente" viraria um laço sem saída.
                        if (response.motivo === 'indisponivel') {
                            const zap = zapMsg ? modal_odonto.whatsappBotao(zapMsg) : '';
                            formElement.html(`
                                <div class="modal-sucesso" role="status" tabindex="-1">
                                    <p class="modal-sucesso-titulo">Não foi possível enviar o comprovante agora</p>
                                    <p class="modal-sucesso-texto">O seu pedido já foi recebido e a nossa equipe vai entrar em contato. O comprovante é só um registro.</p>
                                    ${zap ? `<div class="modal-sucesso-acoes">${zap}</div>` : ''}
                                </div>`);
                            modal_odonto.ativaBotoes();
                            return null;
                        }

                        input.prop('disabled', false);
                        if (response.field_errors) modal_odonto.validaFormulario(formElement, response.field_errors);
                        button.prop('disabled', false).text('Enviar comprovante');
                        statusHint.removeClass('hide').find('small').text('Não foi possível enviar agora. Revise o e-mail e tente novamente.');

                        return null;
                    });
                modal_odonto.preparaFormulario(formElement);
            };

            // Máscara para telefone
            formElement.find('input[name="telefone"]').mask($FUNC.SPMaskBehavior, spOptions);

            // Configuração do botão para marcar consulta
            modal_odonto.md.find('#agendar-confirma').off('click').on('click', function () {
                // Enter chama .trigger('click') (preparaFormulario), que o jQuery entrega MESMO com o
                // botão desabilitado: sem esta guarda o 2º Enter (ou o auto-repeat) durante o envio
                // gravava 2 leads e empurrava 2 agendamento_enviado, a conversão primária do Ads.
                if ($(this).prop('disabled')) return null;
                $(this).prop('disabled', true);

                const nome = formElement.find('input[name="nome"]');
                const telefone = formElement.find('input[name="telefone"]');
                const nome_v = nome.val().trim();
                const telefone_v = telefone.val().replace(/\D/g, '');

                // Validação dos campos
                if (!modal_odonto.validaFormulario(formElement)) {
                    $(this).prop('disabled', false);
                    return null;
                } else {
                    return modal_odonto.ajax(
                        'agendamento',
                        new URLSearchParams({ assunto, nome: nome_v, telefone: telefone_v }).toString(),
                        (response) => {
                            let output = '';

                            // Sucesso
                            if (response.type === 'success') {
                                // Conversão (GTM -> GA4/Ads): agendamento enviado com sucesso.
                                // Gatilho de Evento Personalizado "agendamento_enviado".
                                window.dataLayer = window.dataLayer || [];
                                window.dataLayer.push({
                                    event: 'agendamento_enviado',
                                    agendamento_source: (typeof section_page !== 'undefined' && section_page) ? section_page : (location.pathname || '/'),
                                    agendamento_assunto: assunto,
                                    agendamento_origem: origem
                                });

                                // Duas saídas, na ordem do que o paciente costuma querer:
                                // falar agora (WhatsApp) e guardar o registro (e-mail). O
                                // comprovante era a única porta até 2026-09-12, e quem
                                // queria adiantar a conversa não tinha para onde ir.
                                zapMsg = `Olá! Acabei de pedir agendamento pelo site (${assunto}). Meu nome é ${nome_v}.`;

                                // Sem token (o servidor não conseguiu emitir) não há comprovante
                                // possível: o botão não aparece, em vez de levar a um erro.
                                const botaoComprovante = response.comprovante_token
                                    ? '<button data-acao="email" class="btn btn-default btn-block btn-lg modal-btn-secundario">Receber comprovante por e-mail</button>'
                                    : '';

                                output = `
                                    <div class="modal-sucesso" role="status" tabindex="-1">
                                        <p class="modal-sucesso-selo">Contato recebido 🎉</p>
                                        <p class="modal-sucesso-titulo">${modal_odonto.escapa(nome_v)}, recebemos o seu contato</p>
                                        <p class="modal-sucesso-texto">Agora é só aguardar: nossa equipe vai entrar em contato no telefone <b>${$FUNC.mask.telefone(telefone_v)}</b>. Se a clínica estiver fechada, retornamos a partir do próximo horário de atendimento.</p>
                                        <div class="modal-sucesso-acoes">
                                            ${modal_odonto.whatsappBotao(zapMsg)}
                                            ${botaoComprovante}
                                        </div>
                                    </div>`;
                            }
                            // Erro
                            else {
                                modal_odonto.validaFormulario(formElement, response.field_errors || {});
                                formElement.find('[data-role="envio-status"]').remove();
                                formElement.find('#agendar-confirma').prop('disabled', false).closest('.modal-acao').before(
                                    '<p data-role="envio-status" role="alert" class="text-danger">Não foi possível enviar agora. Revise os campos indicados ou tente novamente em alguns minutos. Seus dados continuam aqui.</p>');
                                return null;
                            }

                            // Exibe o resultado e configura os botões
                            formElement.html(output).find('[data-acao="email"]').off().on('click', () => {
                                return email(response.comprovante_token);
                            });

                            return modal_odonto.ativaBotoes();
                        }
                    );
                }
            });

            // Configuração do modal
            modal_odonto.md
                .one('hidden.bs.modal', () => modal_odonto.md.removeClass('agendamento'))
                .modal({ backdrop: 'static' });
        },

        /**
         * Configura o botão de agendamento
         */
        btn: () => {
            const btn = $('[data-agendar_consulta="true"]');
            if (btn.length) {
                return btn.off('click')
                    .on('click', function (e) {
                        e.preventDefault();
                        // "Agendar avaliação com a Dra. X" nasce DENTRO de um card:
                        // o paciente escolheu uma pessoa, não um assunto. A folha
                        // abre com a identidade dela (foto/nome/CRO) e o formulário
                        // entra por baixo — agendamento.modal() preserva o cabeçalho
                        // quando #the-content já existe. Sem histórico: o destino é
                        // o formulário, não o perfil. O #agendar-consulta de dentro
                        // da folha não casa aqui (não está num card) e segue direto.
                        const card = $(this).closest(modal_odonto.perfil_card);
                        if (card.length) {
                            modal_odonto.perfil(card, { historico: false, origem: 'agendamento' });
                        }
                        const origem = (typeof origemDoClique === 'function') ? origemDoClique(this) : '';
                        return modal_odonto.agendamento.modal($(this).data('assunto'), origem);
                    });
            }
            return null;
        }
    },

    /**
     * Funções relacionadas ao contato
     */
    contato: {
        /**
         * Exibe o modal de contato
         * @param {string} assunto - Assunto do contato
         */
        modal: (assunto) => {
            assunto = assunto || "Contato";
            const form = 'form-contato';
            const thecontent = modal_odonto.md.find('#the-content');

            modal_odonto.md.addClass('agendamento');

            // Adiciona o HTML ao modal
            if (!thecontent.length) {
                modal_odonto.md.find('.modal-body').append(`
                    <div id="the-content">
                        <h3 class="modal-titulo">Enviar <b>${assunto}</b></h3>
                    </div>`);
            }

            modal_odonto.md.find('#the-content').off().append(`
                <div id="${form}" class="text-left animation delay fadeInUp">
                    <label for="${form}-nome">Seu nome</label>
                    <small id="${form}-nome-erro" class="modal-aviso hide"></small>
                    <input id="${form}-nome" name="nome" class="form-control" type="text" autocomplete="name" required minlength="2" maxlength="120" aria-describedby="${form}-nome-erro" placeholder="Seu nome">
                    <br>
                    <label for="${form}-telefone">Telefone</label>
                    <small id="${form}-telefone-erro" class="modal-aviso hide"></small>
                    <input id="${form}-telefone" name="telefone" class="form-control" type="tel" autocomplete="tel-national" inputmode="tel" required maxlength="15" aria-describedby="${form}-telefone-erro" placeholder="celular ou fixo">
                    <br>
                    <label for="${form}-msg">Mensagem</label>
                    <small id="${form}-msg-erro" class="modal-aviso hide"></small>
                    <textarea id="${form}-msg" name="msg" class="form-control" required maxlength="5000" aria-describedby="${form}-msg-erro" rows="4"></textarea>
                    <div class="modal-acao"><button id="agendar-confirma" class="btn btn-default custom-size offline-hide">Enviar</button></div>
                </div>`);

            const formElement = modal_odonto.md.find(`#${form}`);
            modal_odonto.preparaFormulario(formElement);

            // Função para envio de email
            const email = (d) => {
                formElement.off().html(`
                    <br>
                    <label for="${form}-email">Digite seu e-mail</label>
                    <small id="${form}-email-erro" class="modal-aviso hide">Informe um e-mail válido.</small>
                    <input id="${form}-email" name="email" class="form-control" type="email" autocomplete="email" required maxlength="254" aria-describedby="${form}-email-erro" placeholder="Seu e-mail">
                    <br>
                    <div class="modal-acao"><button id="agendar-confirma" class="btn btn-default custom-size offline-hide">Enviar comprovante</button></div>`)
                    .find('#agendar-confirma').off()
                    .on('click', () => {
                        const input = formElement.find('input[name="email"]');
                        const email = input.val().trim();

                        if (modal_odonto.erroCampo(input, !$FUNC.email(email) || email.length > 254 ? 'Informe um e-mail válido.' : '')) {
                            return input.focus();
                        } else {
                            const botaoEmail = formElement.find('#agendar-confirma');
                            if (botaoEmail.prop('disabled')) return null;
                            botaoEmail.prop('disabled', true);
                            // Só token + destino: o comprovante não repete mais nome, assunto
                            // nem mensagem (era relay para qualquer endereço até 2026-09-16).
                            return modal_odonto.ajax(
                                'contato',
                                new URLSearchParams({ id: 2, token: d.token, email }).toString(),
                                (response) => {
                                    if (response.field_errors && response.field_errors.email) {
                                        botaoEmail.prop('disabled', false);
                                        modal_odonto.validaFormulario(formElement, response.field_errors);
                                        return null;
                                    }
                                    const destino = modal_odonto.escapa(email);
                                    let output = '';

                                    // Sucesso
                                    if (response.type === 'success') {
                                        output = `
                                        <div class="modal-sucesso" role="status" tabindex="-1">
                                            <p class="modal-sucesso-selo">Comprovante 😄</p>
                                            <p class="modal-sucesso-titulo">Enviado com sucesso!</p>
                                            <p class="modal-sucesso-texto">para: <b>${destino}</b></p>
                                        </div>`;
                                    }
                                    // Erro
                                    else {
                                        output = `
                                        <div class="modal-sucesso" role="status" tabindex="-1">
                                            <p class="modal-sucesso-titulo text-danger">Ops... ocorreu um erro 😳</p>
                                            <p class="modal-sucesso-texto">Desculpe o transtorno. Não foi possível enviar o e-mail para: <b>${destino}</b></p>
                                        </div>`;
                                    }

                                    // Exibe o resultado
                                    formElement.html(output).find('.modal-sucesso').trigger('focus');
                                    return formElement;
                                }
                            );
                        }
                    });
                modal_odonto.preparaFormulario(formElement);
            };

            // Máscara para telefone
            formElement.find('input[name="telefone"]').mask($FUNC.SPMaskBehavior, spOptions);

            // Configuração do botão de envio de mensagem
            modal_odonto.md.find('#agendar-confirma').off('click').on('click', function () {
                const botao = $(this);
                // Mesma guarda do agendamento acima: Enter durante o envio não pode reenviar.
                if (botao.prop('disabled')) return null;
                botao.prop('disabled', true);

                const d = {
                    assunto: assunto,
                    nome: formElement.find('input[name="nome"]'),
                    telefone: formElement.find('input[name="telefone"]'),
                    msg: formElement.find('textarea[name="msg"]')
                };

                d.nome_v = d.nome.val().trim();
                d.telefone_v = d.telefone.val().replace(/\D/g, '');
                d.msg_v = d.msg.val().trim();

                // Validação dos campos
                if (!modal_odonto.validaFormulario(formElement)) {
                    $(this).prop('disabled', false);

                    return null;
                } else {
                    // URLSearchParams codifica cada campo: com a interpolação crua de antes,
                    // um "&" na mensagem cortava o texto que chegava aos responsáveis.
                    return modal_odonto.ajax(
                        'contato',
                        new URLSearchParams({ id: 1, assunto: d.assunto, nome: d.nome_v, telefone: d.telefone_v, msg: d.msg_v }).toString(),
                        (response) => {
                            // Erro: o formulário FICA como está. A Ouvidoria não é gravada em
                            // lugar nenhum — o e-mail aos responsáveis é o registro —, então
                            // trocar a tela por "tente mais tarde" (como era até 2026-09-16)
                            // jogava fora o texto que a pessoa escreveu. Botão reabilitado:
                            // tentar de novo é só clicar.
                            if (response.type !== 'success') {
                                modal_odonto.validaFormulario(formElement, response.field_errors || {});
                                formElement.find('[data-role="contato-status"]').remove();
                                botao.prop('disabled', false).closest('.modal-acao').before(`
                                    <p class="modal-texto text-danger" data-role="contato-status" role="alert"><small>Não foi possível enviar agora. A sua mensagem continua aqui: tente novamente em alguns minutos.</small></p>`);
                                return null;
                            }

                            d.token = response.comprovante_token;
                            const botaoComprovante = d.token
                                ? '<div class="modal-sucesso-acoes"><button data-acao="email" class="btn btn-default btn-block btn-lg modal-btn-secundario">Receber comprovante por e-mail</button></div>'
                                : '';
                            const output = `
                                <div class="modal-sucesso" role="status" tabindex="-1">
                                    <p class="modal-sucesso-selo">Contato recebido 🎉</p>
                                    <p class="modal-sucesso-titulo">${modal_odonto.escapa(d.nome_v)}, obrigado pela mensagem</p>
                                    <p class="modal-sucesso-texto">O contato será encaminhado aos responsáveis pela área citada. Telefone informado: <b>${$FUNC.mask.telefone(d.telefone_v)}</b>.</p>
                                    ${botaoComprovante}
                                </div>`;

                            // Exibe o resultado e configura o botão de email
                            formElement.html(output).find('[data-acao="email"]').off().on('click', () => email(d));
                            formElement.find('.modal-sucesso').trigger('focus');
                            return formElement;
                        }
                    );
                }
            });

            // Configuração do modal
            modal_odonto.md
                .one('hidden.bs.modal', () => modal_odonto.md.removeClass('agendamento'))
                .modal({ backdrop: 'static' });
        },

        /**
         * Configura o botão de contato
         */
        btn: () => {
            const btn = $('#contato_preencher');
            if (btn.length) {
                return btn.off('click')
                    .on('click', function (e) {
                        e.preventDefault();
                        return modal_odonto.contato.modal($(this).data('contato'));
                    });
            }
            return null;
        }
    },

    /**
     * Perfil do dentista lido do PRÓPRIO card (article.equipe-card): desde
     * 2026-08-21 o currículo vive em DOM real (sections/meu-dentista.php) e o
     * modal é só outra vista dele — nada de data-md-* duplicando dado. As
     * linhas do currículo já chegam sanitizadas do servidor (curriculoLinhas:
     * escape + whitelist <b>/<i>), por isso o innerHTML delas é seguro.
     * A estrutura (main-image/the-content/esconde) é a mesma de sempre: o
     * fluxo AGENDAR CONSULTA → .agendamento esconde o perfil por CSS.
     */
    dentista: () => {
        modal_odonto.equipe_busca();
        const btn = $('[data-equipe-perfil]');
        if (btn.length) {
            // Foto que falhar (ERP fora, arquivo sumido) vira o placeholder de
            // data-fallback — senão o alt vaza num filete dentro do círculo.
            $('.equipe-foto[data-fallback]').each((_, img) => {
                const fallback = () => {
                    // Uma candidata quebrada continuaria vencendo o src de fallback.
                    img.removeAttribute('srcset');
                    img.removeAttribute('sizes');
                    if (!img.src.endsWith(img.dataset.fallback)) img.src = img.dataset.fallback;
                };
                if (img.complete && img.naturalWidth === 0) fallback();
                else img.addEventListener('error', fallback, { once: true });
            });

            // O <summary> dos cards da GRADE abre a mesma folha que a foto, em
            // vez de expandir no próprio card: ali a linha tem ~40 caracteres
            // contra ~73 na folha, e duas portas para o mesmo conteúdo com
            // apresentações diferentes era ruído. Progressive enhancement — sem
            // JS o <details> continua abrindo nativamente, que é o que mantém o
            // currículo indexável. O card de DESTAQUE (RT) fica de fora: está
            // `open` numa coluna larga, onde a leitura inline é boa.
            $('.equipe-grade-row .equipe-curriculo').addClass('equipe-curriculo--folha')
                .children('summary').attr('aria-haspopup', 'dialog')
                .off('click').on('click', function (e) {
                    e.preventDefault(); // sem isto o <details> ainda alternaria por baixo
                    abrirPerfil.call(this);
                    return false;
                });

            // Título da LISTAGEM, para restaurar ao fechar a folha. Vem do
            // markup, não de document.title: em chegada direta o servidor já
            // mandou o título do dentista, e usar isso como base deixaria a aba
            // nomeando alguém que não está mais na tela.
            modal_odonto.perfil_rota.titulo_base =
                $('#meu-dentista').data('titulo-base') || document.title;

            // Chegada direta em /meu-dentista/{slug}: abre a folha daquele
            // profissional. Só na carga do documento — a navegação AJAX entra
            // sempre em /meu-dentista sem filho, então não reabre sozinha.
            const slugUrl = modal_odonto.perfil_rota.slugDaUrl();
            if (slugUrl) {
                const alvo = $(`.equipe-card[data-slug="${slugUrl}"]`);
                // Slug que não casa com card nenhum: limpa a URL em vez de
                // deixar o endereço mentindo sobre o que está na tela.
                if (alvo.length) modal_odonto.perfil(alvo, { historico: false, origem: 'url' });
                else history.replaceState(null, '', modal_odonto.perfil_rota.base);
            }

            // A origem viaja até o dataLayer e vem do ATRIBUTO do gatilho
            // (data-perfil-origem, em sections/meu-dentista.php): é ela que
            // responde se o card inteiro e o rótulo do rodapé eram necessários
            // ou se a foto já bastava — a pergunta que não tinha resposta antes
            // de 2026-09-03. Gatilho novo sem o atributo cai no default do
            // caller em vez de ser contado como foto.
            const abrirPerfil = function () {
                return modal_odonto.perfil($(this).closest('.equipe-card'), {
                    origem: this.dataset.perfilOrigem || 'card',
                });
            };

            // O CARD INTEIRO abre a folha (2026-09-03). Só na GRADE: o card de
            // destaque nasce `open` numa coluna larga e é superfície de
            // LEITURA — clicar ali para reabrir o mesmo currículo num modal
            // seria roubar a seleção de texto sem entregar nada.
            $('.equipe-grade-row .equipe-card')
                .off('click.perfil')
                .on('click.perfil', function (e) {
                    // Quem tem porta própria (foto, "Ver perfil", <summary>,
                    // "Agendar avaliação com…") já tratou o clique; deixar
                    // borbulhar abriria a folha duas vezes e empurraria dois
                    // estados no histórico.
                    if (e.target.closest('a, button, summary')) return;
                    // Copiar o CRO para conferir no site do CRO-SP é uso
                    // legítimo do card: arrastar sobre o texto não é clique.
                    // isCollapsed e não toString(): o mousedown já colapsa a
                    // seleção anterior, então só sobra a que o próprio gesto
                    // criou — e é a forma que dá para exercitar num teste
                    // (em documento sem foco a Selection stringifica vazia).
                    const sel = window.getSelection();
                    if (sel && !sel.isCollapsed) return;
                    modal_odonto.perfil($(this), { origem: 'card' });
                });

            return btn.off('click').on('click', abrirPerfil);
        }
        return null;
    },

    /**
     * Rota da folha de perfil: /meu-dentista/{slug}.
     *
     * A URL existe para o botão VOLTAR e para compartilhar ("olha o currículo
     * dele") — não para ranquear: o servidor devolve a MESMA página, então o
     * canonical de todo filho aponta para /meu-dentista (include/config.php).
     * O que muda de verdade no servidor é <title>/og:*, que é o que o WhatsApp
     * lê ao montar o cartão do link.
     */
    perfil_rota: {
        base: '/meu-dentista',
        titulo_base: '',
        empurrou: false,

        slugDaUrl: () => {
            const m = location.pathname.match(/^\/meu-dentista\/([a-z0-9-]+)\/?$/);
            return m ? m[1] : null;
        },

        // Volta ao estado da listagem. history.back() só quando fomos NÓS que
        // empurramos — em chegada direta ele levaria o visitante para fora do
        // site, que é o oposto de fechar um modal.
        limpa: () => {
            const r = modal_odonto.perfil_rota;
            if (r.empurrou) {
                r.empurrou = false;
                history.back();
                return;
            }
            if (r.slugDaUrl()) history.replaceState(null, '', r.base);
            if (r.titulo_base) document.title = r.titulo_base;
        }
    },

    /**
     * Cards de dentista que perfil() sabe ler. São DOIS vocabulários porque são
     * dois visuais: .equipe-* (/meu-dentista; a home adota e neutraliza o visual
     * no CSS) e .profissional-* (grade "Escolha com quem agendar" das landings de
     * tratamento, sections/complementos/tratamento-landing.php). O card da landing
     * NÃO adota .equipe-*: levaria junto o visual da /meu-dentista e exigiria CSS
     * só para desfazê-lo. Card de dentista novo usa um dos dois, nunca um terceiro.
     */
    perfil_card: '.equipe-card, .profissional-card',

    // Enhancement local: sem JS todos os perfis e currículos continuam no DOM.
    // Cada nova section AJAX recebe seus handlers uma vez; reinicializar preserva a busca.
    equipe_busca: () => {
        const equipe = document.getElementById('equipe-lista');
        const busca = equipe && equipe.querySelector('.equipe-busca');
        if (!busca || busca.dataset.inicializada) return;
        const campo = busca.querySelector('input');
        const limpar = busca.querySelector('[data-equipe-limpar]');
        const status = busca.querySelector('[role="status"]');
        const normalizar = texto => texto.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase('pt-BR').trim();
        const cards = Array.from(equipe.querySelectorAll('.equipe-card')).map(card => ({
            nome: normalizar(card.querySelector('.equipe-nome').textContent),
            elemento: card.classList.contains('equipe-card--destaque') ? card : card.parentElement
        }));
        const intro = equipe.querySelector('.equipe-grade-intro');
        const atualizar = () => {
            const termo = normalizar(campo.value);
            const partes = termo.split(/\s+/);
            let encontrados = 0;
            cards.forEach(card => {
                card.elemento.hidden = !partes.every(parte => card.nome.includes(parte));
                if (!card.elemento.hidden) encontrados++;
            });
            limpar.hidden = campo.value.length === 0;
            if (intro) intro.hidden = termo.length > 0;
            status.textContent = encontrados === 0
                ? 'Nenhum dentista encontrado. Tente parte do nome ou limpe a busca para ver toda a equipe.'
                : `${encontrados} ${encontrados === 1 ? 'dentista encontrado' : 'dentistas encontrados'}.`;
        };
        campo.addEventListener('input', atualizar);
        limpar.addEventListener('click', () => {
            campo.value = '';
            atualizar();
            campo.focus();
        });
        atualizar();
        busca.dataset.inicializada = 'true';
        busca.hidden = false;
    },

    /**
     * Monta a folha de perfil a partir do DOM de um card (perfil_card).
     * opts.historico=false monta sem mexer na URL — usado na chegada direta
     * (a URL já é a certa) e no fluxo "Agendar avaliação com…", que termina
     * no formulário, não no perfil.
     */
    perfil: (card, opts = {}) => {
        if (!card || !card.length) return null;

        const rota = modal_odonto.perfil_rota;
        const foto = card.find('.equipe-foto').attr('src') || card.find('img').attr('src') || '';
        const nome = card.find('.equipe-nome, .profissional-nome').first().text().trim();
        const cro = card.find('.equipe-cro, .profissional-cro').first().text().trim();
        const linhas = card.find('.equipe-curriculo-linhas li');
        const assunto = card.find('.equipe-agendar-com a, .profissional-acao a').data('assunto') || `Consulta — ${nome}`;
        // .text() devolve texto decodificado: ao voltar para um template HTML,
        // nomes/CRO e o assunto precisam de escape de novo, inclusive aspas.
        // O currículo segue HTML sanitizado por curriculoLinhas() no servidor.
        const esc = value => String(value).replace(/[&<>"']/g, char => ({
            '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
        })[char]);

        let html = `
                    <div id="main-image">
                        <div id="the-image" class="autocrop-image"></div>
                    </div>
                    <div id="the-content">
                        <div id="the-content-wrapper">
                            <h2 class="text-animation">${esc(nome)}</h2>`;

        if (cro) {
            html += `<p class="cro text-animation">${esc(cro)}</p>`;
        }

        if (linhas.length) {
            html += '<p class="estudo esconde"><i class="de-icon-graduation-cap"></i>&nbsp;&nbsp;Formação e atuação</p>';
            linhas.each((i, li) => {
                html += `<p class="list-estudo esconde">${li.innerHTML}</p>`;
            });
        } else {
            html += '<p class="list-estudo esconde">Para saber mais sobre o atendimento com este profissional, fale com nossa equipe ou solicite uma avaliação.</p>';
        }

        // CTA numa faixa sticky no rodapé da folha (.modal-acao): num
        // currículo longo no celular o botão não some na rolagem e, no
        // fim, assenta no lugar natural. .esconde some com ele no fluxo
        // de agendamento, que traz o próprio botão.
        html += `
                            <div class="modal-acao esconde"><button id="agendar-consulta" data-agendar_consulta="true" data-assunto="${esc(assunto)}" class="btn btn-default custom-size offline-hide">Agendar avaliação</button></div>
                        </div>
                    </div>`;

        modal_odonto.md.modal({ backdrop: 'static', keyboard: true }).find('.modal-body').append(html);
        // A URL da foto entra como propriedade CSS, nunca como markup/atributo.
        modal_odonto.md.find('#the-image').css('background-image', `url(${JSON.stringify(foto)})`);

        // Título anda junto com a URL, nunca sozinho: no fluxo "Agendar
        // avaliação com…" (historico:false) o endereço segue /meu-dentista, e
        // renomear a aba para a dentista faria aba e barra contarem histórias
        // diferentes. No popstate a URL já mudou: atualizarTitulo sincroniza
        // a aba sem criar outra entrada. Na chegada direta o título vem do PHP.
        const slug = card.data('slug');
        if (opts.historico !== false && slug) {
            if (!rota.titulo_base) rota.titulo_base = document.title;
            history.pushState({ perfil: slug }, '', `${rota.base}/${slug}`);
            rota.empurrou = true;
        }
        if ((opts.historico !== false || opts.atualizarTitulo === true) && card.data('titulo')) {
            document.title = card.data('titulo');
        }

        // Configuração do botão de agendamento
        modal_odonto.agendamento.btn();

        // A abertura da folha vai para o dataLayer: até 2026-09-03 a única
        // coisa medida nesta página era `agendamento_enviado` (o fim do
        // funil), então não havia como saber se o perfil era usado — nem por
        // qual porta. Push puro, sem cookie: quem decide o que disparar é o
        // GTM, sob o Consent Mode v2.
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'perfil_dentista_aberto',
            perfil_dentista: slug || '',
            perfil_origem: opts.origem || 'card',
        });

        return false;
    },

    /**
     * Configura os botões de ouvidoria
     */
    ouvidoria: () => {
        const btn = $('[data-contato]');
        if (btn.length) {
            return btn.off('click').on('click', function (e) {
                e.preventDefault();
                const dados = e.currentTarget.attributes;

                // Construção do HTML do modal
                const html = `
                    <div id="main-image" class="main-image--ilustracao">
                        <div id="the-image" class="autocrop-image" style="background-image:url(/img/equipe/odonto-luz-contato.png);background-size: contain;"></div>
                    </div>
                    <div id="the-content">
                        <div id="the-content-wrapper" class="text-left">
                            <h2 class="text-animation">${dados['data-contato'].value}</h2><br>
                            <p class="fa fa-quote-left estudo esconde"></p>
                            <p class="list-estudo esconde">${dados['data-conteudo'].value}</p>
                            <div class="modal-acao esconde">
                                <button id="contato_preencher" data-contato="${dados['data-contato'].value}" class="btn btn-default custom-size offline-hide">Preencher</button>
                            </div>
                        </div>
                    </div>`;

                modal_odonto.md.modal({ backdrop: 'static', keyboard: true }).find('.modal-body').append(html);

                // Configuração do botão de contato
                modal_odonto.contato.btn();
            });
        }
        return null;
    },

    /**
     * Inicializa todos os componentes do modal
     */
    int: () => {
        modal_odonto.modal_html();
        modal_odonto.agendamento.btn();
        modal_odonto.dentista();

        // Voltar/avançar do navegador sincroniza a folha com a URL. Uma vez só:
        // int() roda de novo a cada navegação AJAX e empilharia listeners.
        if (!modal_odonto.perfil_rota.ligado) {
            modal_odonto.perfil_rota.ligado = true;
            window.addEventListener('popstate', () => {
                const rota = modal_odonto.perfil_rota;
                const slug = rota.slugDaUrl();
                rota.empurrou = false; // quem manda agora é a URL, não o que empurramos

                if (!slug) {
                    if (rota.titulo_base) document.title = rota.titulo_base;
                    if (modal_odonto.md && modal_odonto.md.hasClass && modal_odonto.md.hasClass('in')) {
                        modal_odonto.md.modal('hide');
                    }
                    return;
                }

                const card = $(`.equipe-card[data-slug="${slug}"]`);
                if (card.length) modal_odonto.perfil(card, { historico: false, atualizarTitulo: true, origem: 'historico' });
            });
        }
    }
};

/**
 * Sistema de alertas
 */
const alertm = {
    idModal: 'alertModal',

    /**
     * Exibe um alerta modal
     * @param {string} t - Título do alerta
     * @param {string} d - Conteúdo do alerta
     */
    md: function (t, d) {
        const id = this.idModal;
        const modal = `
            <div id="${id}" class="modal fade" tabindex="-1" role="dialog" aria-modal="true" aria-labelledby="${id}-titulo">
                <div class="modal-dialog modal-lg">
                    <div class="modal-content">
                        <div class="modal-header">
                            <p id="${id}-titulo" class="modal-title">${t || 'Notificação'}</p>
                        </div>
                        <div class="modal-body"></div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-default" data-dismiss="modal">OK</button>
                        </div>
                    </div>
                </div>
            </div>`;

        if (!$(`#${id}`).length) {
            $('body').append(modal);
        }

        const modalElement = $(`div#${id}`);

        return modalElement
            .one('show.bs.modal', () => {
                modalElement.find('.modal-body').off().html(d);
            })
            .one('hidden.bs.modal', () => {
                modalElement.off().remove();
            })
            .modal({ backdrop: 'static', keyboard: true });
    },

    /**
     * Esconde o modal de alerta
     */
    hide: function () {
        return $(`#${this.idModal}`).modal('hide');
    }
};
